module.exports = __webpack_public_path__ + "img/DiferenciaHoraPanelEnActivacion.d972ef80.svg";